import { IWTButton } from '../IWTButton';
import { useHistory } from 'react-router-dom';
import { Pages } from '../../../utils/constants';
import { useGlobalState } from '../../../state/state';
import { isAddFamilyMembersAllowed } from '../../../state/helpers';
import { hasPITOrPendingChange } from '../../../utils/ruleHelper';
import { useState } from 'react';
import { PITWarningModal } from '../../PITWarningModal/PITWarningModal';

export interface IAddFamilyMembersIWTProps {
  variant?: 'small';
}

export const AddFamilyMembersIWT = ({ variant }: IAddFamilyMembersIWTProps) => {
  const history = useHistory();
  const [membershipDetails] = useGlobalState('memberDetails');
  const addFamilyMembersAllowed = isAddFamilyMembersAllowed(membershipDetails);
  const [showPITWarningModal, setShowPITWarningModal] = useState(false);
  const hasPITPendingChange = hasPITOrPendingChange(membershipDetails);
  const onClick = () => {
    if (hasPITPendingChange) {
      setShowPITWarningModal(true);
    } else {
      history.push(Pages.RoleTypeSelection);
    }
  };

  return (
    <>
      <div className="add-family-member-iwt-container" hidden={!addFamilyMembersAllowed}>
        <IWTButton title="Add family members" id="AddFamilyMembersIWT" variant={variant} onClick={onClick} />
      </div>
      <PITWarningModal
        visible={showPITWarningModal}
        onClose={() => {
          setShowPITWarningModal(false);
        }}
      />
    </>
  );
};
